import { Routes } from '@angular/router';
import { MissionCategoryComponent } from './mission-category/mission-category.component';
import { MissionRulesComponent } from './mission-rules/mission-rules.component';
import { MainMissionRouteComponent } from './main-mission/main-mission.component';

export const MISSIONS_MODULE_NOT_TRANSLATED: Routes = [
  {
    path: '', component: MissionCategoryComponent, children: []
  },
  {
    path: 'id/:id', component: MainMissionRouteComponent, children: [
      { path: 'info', component: MissionRulesComponent }
    ]
  },
];
